import type { RouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const deleteOrderPost = async ({ routeParams: { id } }: RouteParamsRequest<{ id: string }>) =>
  apiClient.delete<unknown, ApiClientResponse<unknown>>(routes.withings.deleteOrderPost(id));
